import styled, { css } from 'styled-components';

import { MeetControlProps } from './MeetControl';

const backgroundColor = (
	color: string | undefined,
	disabled = false,
	off = false,
	withMenu = false
) => {
	if (disabled || off) {
		return '#FFE5E8';
	}

	if (withMenu) {
		return '#f8f8f8';
	}

	return color ? color : '#ffffff';
};

export const MeetControlContainer = styled.div<MeetControlProps>`
	${({ theme, disabled, $menuOpened, $withMenu }) => css`
		${$withMenu && `background-color: ${theme.colors.neutral[100]};`}
		box-shadow: ${theme.shadows.base};
		${$menuOpened && `box-shadow: 0px 0px 0px 1px ${theme.colors.brand.accent[300]};`}
		border-radius: ${theme.radii.l};

		display: flex;
		flex-direction: row;

		${disabled && 'pointer-events: none;'}
		user-select: none;
	`}
`;

export const MeetControlCta = styled.div<MeetControlProps>`
	${({ disabled, $off, $withMenu, color }) => css`
		width: 48px;
		height: 48px;
		background-color: ${backgroundColor(color, disabled, $off, $withMenu)};
		border-radius: 36px;

		display: grid;
		place-content: center;
	`}
`;

export const MeetControlMenu = styled.div<MeetControlProps>`
	display: grid;
	place-content: center;
	height: 100%;
	padding: 0 11px;
`;
